import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import {
  success,
  error,
  loading,
  Updateloading,
} from "../common/helpers/toastify";
import Select from "react-select";
import { poscustomorder_head1 } from "../../components/common/Tablehead";
import { Pagination } from "../common/Pagination";
import CheckoutBlank from "../checkout/checkoutBlank";
import { Customsubtable } from "./SubTablePos/Customsubtable";
import "./poscustom.scss";
import { _Api } from "../common/api/_call";
import { store } from "../../source/index";
import { useSelector } from "react-redux";
import CustomerSearchModal from "../common/module/customerSearch";
import TableColumnModal from "../../components/common/modules/tableColumn";
import { toFormatPrice, toUnformatPrice } from "../common/helpers/function";
import CheckoutSell from "../checkout/checkoutSell";
import CheckoutPayment from "../checkout/checkoutPayment";
import { useTranslation } from "react-i18next";
import ConfirmationModel from "../../admin/common/modules/confirmationmodel";
import DropdownFilter from "./DropdownFilter";
// import { by } from '@fullcalendar/core/internal-common';

const parseOrderDate = (value) => {
  if (!value) return null;
  const parsed = moment(
    value,
    ["DD/MM/YYYY", "MM/DD/YYYY", "YYYY/MM/DD", "YYYY-MM-DD", "DD-MM-YYYY"],
    true
  );
  if (parsed.isValid()) return parsed.valueOf();
  const fallback = moment(value);
  return fallback.isValid() ? fallback.valueOf() : null;
};

const toNumber = (value) => {
  if (value === null || value === undefined || value === "") return null;
  const num = Number(String(value).replace(/[^0-9.-]/g, ""));
  return Number.isNaN(num) ? null : num;
};

// Sort accessor per column index of poscustomorder_head1.
const SORT_ACCESSORS = [
  null,
  null,
  null,
  (r) => parseOrderDate(r?.transaction_date),
  (r) => r?.order_no,
  (r) => r?.SKU,
  (r) => r?.customer,
  (r) => toNumber(r?.Qty),
  (r) => toNumber(r?.amount),
  (r) => toNumber(r?.payment),
  (r) => toNumber(r?.balance_due),
  (r) => parseOrderDate(r?.delivery_date),
];

const PosOrderList = () => {
  const { t } = useTranslation();
  let navigate = useNavigate();
  let reduxdata = store.getState();
  let OrgSettings = reduxdata?.app?.posorganisation_settings;
  const base_assets = process.env.REACT_APP_BASE_ASSETS_URL;
  const [newcolumndata, setnewcolumndata] = useState(poscustomorder_head1);
  const customer = useSelector((state) => state.app.customer);
  const saleperson = useSelector((state) => state.app.saleperson);
  const [orderlist, setOrderlist] = useState();
  const [orderTotal, setOrderTotal] = useState();
  const [, setdeletestatus] = useState(false);
  const [searchproductstatus, setsearchproductstatus] = useState(false);
  const parmissiondatashow = useSelector((state) => state.app.ApplyParmission);
  const [orderid, setOrderid] = useState("");
  const [showcheckout, setShowcheckout] = useState("blank");
  const [showpayment, setShowpayment] = useState(false);
  const [UpdatedCart, setUpdatedCart] = useState();
  const [TransactionDate, setTransactionDate] = useState(new Date());
  const [excuteTable, setexcuteTable] = useState(false);
  const [searchlist, setSearchlist] = useState();
  const [customerid, setCustomerid] = useState();
  const [statement, setStatement] = useState("");
  const [currentIdToChange, setCurrentIdToChange] = useState({});
  const [selecteditem, setSelecteditem] = useState([]);
  console.log(selecteditem, "selecteditem");
  const [limit, setLimit] = useState(50);
  const [searchKey, setSearchKey] = useState();
  const [selectedFilters, setSelectedFilters] = useState([]);
  const [sortConfig, setSortConfig] = useState({ index: null, direction: "asc" });

  // Column settings come from the API; only trust them when they match this table's columns.
  const columnSettings =
    Array.isArray(newcolumndata) &&
    newcolumndata.length === poscustomorder_head1.length
      ? newcolumndata
      : poscustomorder_head1;
  const isColumnVisible = (index) => columnSettings[index]?.status !== false;
  const visibleColumnCount = poscustomorder_head1.filter((_, index) =>
    isColumnVisible(index)
  ).length;

  const handleSort = (index) => {
    setSortConfig((prev) =>
      prev.index === index
        ? { index, direction: prev.direction === "asc" ? "desc" : "asc" }
        : { index, direction: "asc" }
    );
  };

  const sortedOrderlist = useMemo(() => {
    const list = Array.isArray(orderlist) ? orderlist : [];
    const accessor = SORT_ACCESSORS[sortConfig.index];
    if (!accessor) return list;
    const sorted = [...list].sort((a, b) => {
      const av = accessor(a);
      const bv = accessor(b);
      if (av === undefined || av === null || av === "") return 1;
      if (bv === undefined || bv === null || bv === "") return -1;
      if (typeof av === "number" && typeof bv === "number") return av - bv;
      return String(av).localeCompare(String(bv), undefined, { numeric: true });
    });
    return sortConfig.direction === "asc" ? sorted : sorted.reverse();
  }, [orderlist, sortConfig]);

  const [state, setstate] = useState({
    totalPages: 20,
    currentPage: 1,
  });

  const { totalPages, currentPage } = state;
  const handlePaginations = (current) => {
    setstate({ ...state, currentPage: current });
    Getcustomeorder(current);
  };

  const colorStyles = {
    option: (styles, { data }) => {
      return {
        ...styles,
        backgroundColor: data.color,
      };
    },
  };
  const selectOptions = [
    { label: 50, value: 50 },
    { label: 100, value: 100 },
    { label: 150, value: 150 },
  ];
  const changeStatus = (index, value, po_order_id, statusid) => {
    setStatement("Change Status");
    setCurrentIdToChange({ status: statusid, id: po_order_id });
    // setPo_sataus([{ index: index, status: value, po_order_id: po_order_id }]);
    document.querySelector("#status_query_select").click();
  };
  useEffect(() => {
    callcolumns();
  }, []);
  const callcolumns = async () => {
    try {
      const postdata = {
        name: "tbl_pos_customorderdelivered",
      };
      let columnhead = await _Api(
        postdata,
        `api/v1/Inventory/common/getColumnHeads`
      );
      if (columnhead.code === 200) {
        setnewcolumndata(columnhead?.data?.data);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const clearItems = () => {
    setSelecteditem([]);
    setOrderlist((prevList) =>
      prevList.map((item) => ({ ...item, rowClass: "" }))
    );
  };
  const Getcustomeorder = async (current, firstlimit, search) => {
    setexcuteTable(false);
    let limit1 = firstlimit ? firstlimit : limit;
    document
      .querySelectorAll(".table_btn_expand_col")
      .forEach((expand_col) => expand_col.classList.remove("rotate-90"));
    try {
      const postdata = {
        orderfilter: selectedFilters?.length ? selectedFilters : null,
        searchKey: search ? search : searchKey,
        limit: firstlimit ? firstlimit : limit,
        skip: current ? (current - 1) * limit1 : 0,
        customer_id: customer?.id,
      };
      let res = await _Api(postdata, `api/v1/POS/customOrder/customOrderList`);
      if (res.code === 200) {
        setstate((prev) => ({
          ...prev,
          totalPages: Math.ceil(res?.count / postdata?.limit),
          currentPage: current ? current : 1,
        }));
        setexcuteTable(true);
        setOrderlist(res?.data);
        setOrderTotal(res?.summary);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const getlimit = (limit) => {
    setLimit(limit);
    Getcustomeorder(1, limit);
    setstate({ ...state, currentPage: 1 });
  };
  useEffect(() => {
    if (customer?.id) {
      Getcustomeorder();
    } else {
      Getcustomeorder();
    }
    // eslint-disable-next-line
  }, [customer?.id, TransactionDate]);

  const setSubTablecustom = async (order_id) => {
    var e = document.querySelector("#table-btn_" + order_id);
    if (!e) return;
    var classList_ = e.classList;
    if (classList_.contains("rotate-90")) {
      classList_.remove("rotate-90");
      setOrderlist((prev) =>
        prev.map((item) =>
          item.order_id === order_id ? { ...item, subTabledata: null } : item
        )
      );
    } else {
      classList_.add("rotate-90");
      const postdata = {
        Order_id: order_id,
      };
      let prioritydata = await _Api(
        postdata,
        `api/v1/POS/customOrder/getSkuByOrderList`
      );
      var html_ = Customsubtable(prioritydata, order_id, t);
      // The sub-table renders right after its row, so it follows the row when sorting.
      setOrderlist((prev) =>
        prev.map((item) =>
          item.order_id === order_id ? { ...item, subTabledata: html_ } : item
        )
      );
    }
  };
  // const GetCartdetailorder = async () => {
  //   try {
  //     const postdata = {
  //       "order_id": orderid,
  //       'order_type': 'custom_order',
  //       "by_custom_order": true
  //     }
  //     let res = await _Api(postdata, `api/v1/POS/customOrder/getCartItems`)
  //     if (res.code === 200) {
  //       setUpdatedCart(res?.data);
  //       setShowcheckout('sell');
  //     } else {
  //       navigate('/app/pos/custom/customOrderDelivered')
  //     }
  //   } catch (err) {
  //     console.log(err, 'err')
  //   }
  // }
  // const GetCartdetailorder = async () => {
  //   if(orderid){
  //     navigate('/app/pos/posscreen',{state:{order_id: orderid, order_type: 'custom_order',by_custom_order: true}})
  //   }
  // }
  const GetCartdetailorder = async () => {
    if (selecteditem?.length) {
      navigate("/app/pos/posscreen", {
        state: {
          state1: {
            order_id: selecteditem,
            order_type: "custom_order",
            by_custom_order: true,
          },
        },
      });
    } else {
      error(t("No item selected!"));
    }
  };

  const getsearchlist = async (value) => {
    try {
      const posdata = {
        search: value,
        type: "inventory",
        from: "createYourOwn",
      };
      let res = await _Api(posdata, `api/v1/POS/customOrder/skuNameBySearch`);
      if (res.code === 200) {
        setSearchlist(res?.data);
      } else {
        setSearchlist([]);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };
  const AddtoCart = async (product_id) => {
    if (!customer?.id) {
      error(t("Customer is Requried!!"));
      return;
    }
    if (!saleperson?.value) {
      error(t("SalePerson is Requried!!"));
      return;
    }
    const GetloadingID = loading();
    try {
      const postdata = {
        product_id: product_id,
        type: "inventory",
        customer_id: customer?.id,
        sales_person_id: saleperson?.value,
        order_type: "custom_order",
      };
      let res = await _Api(postdata, `api/v1/POS/customOrder/addItemToCart`);
      if (res.code === 200) {
        Updateloading(t, GetloadingID, t("Successfully Add to Cart!!"));
        setShowcheckout("sell");
        setsearchproductstatus(true);
      } else {
        Updateloading(t, GetloadingID, t("This Product Already in cart!!"), "error");
      }
    } catch (err) {
      console.log(err, "err");
      Updateloading(t, GetloadingID, t("Something went wrong"), "error");
    }
  };
  const getprintcustomorder = async () => {
    if (!customer?.id && !customerid) {
      error(t("Customer is Requried!!"));
      return;
    }
    let GetloadingID = loading();
    try {
      const postdata = {
        customer_id: customerid ? customerid : customer?.id,
      };
      let res = await _Api(
        postdata,
        `api/v1/POS/reports/print/customOrderOutstanding`
      );

      if (res.code === 200) {
        setTimeout(() => {
          const exportLinkElement = document.createElement("a");
          exportLinkElement.hidden = true;
          exportLinkElement.download = res?.name ? res?.name : "report.pdf";
          exportLinkElement.href = res?.link;
          exportLinkElement.text = "downloading...";
          exportLinkElement.setAttribute("target", "_blank");
          document.body.appendChild(exportLinkElement);
          exportLinkElement.click();
          exportLinkElement.remove();
          Updateloading(t, GetloadingID, t("download successfully"));
        }, 50);
      }
      if (res.code === 400) {
        Updateloading(t, GetloadingID, res?.messgae, t("error"));
      }
    } catch (err) {
      console.log(err, "err");
      Updateloading(t, GetloadingID, err, t("error"));
    }
  };
  // const selectedproduct = (event, id, ststus) => {
  //   if (event.target.checked) {
  //     if (ststus === 5) {
  //       setOrderid(id);
  //     } else {
  //       setOrderid("");
  //     }
  //   } else {
  //     setOrderid("");
  //   }
  // };
  const selectedproduct = (event, ordertype) => {
    let updatedSelected;

    if (event.target.checked) {
      // Base object
      let newItem = { id: event.target.value, order_type: ordertype };

      // Add property conditionally
      if (ordertype === "custom_order") {
        newItem.by_custom_order = true;
      } else if (ordertype === "repair_order") {
        newItem.by_repair_order = true;
      } else if (ordertype === "reserve") {
        newItem.reserve_sell = true;
      }

      updatedSelected = [...selecteditem, newItem];
    } else {
      updatedSelected = selecteditem.filter(
        (element) => element.id !== event.target.value
      );
    }

    setSelecteditem(updatedSelected);

    // Determine selected customer
    let selectedCustomer = null;
    if (updatedSelected.length > 0) {
      const firstSelectedId = updatedSelected[0].id;
      const firstSelectedRow = orderlist.find(
        (row) => row.order_id == firstSelectedId
      );
      selectedCustomer = firstSelectedRow?.customer_id || null;
    }

    // Shallow copy of orderlist
    let mainarray = [...orderlist];

    // Manipulate the copy in place
    mainarray.forEach((row, index) => {
      if (!selectedCustomer) {
        mainarray[index] = { ...row, rowClass: "" };
      } else if (row.customer_id !== selectedCustomer) {
        mainarray[index] = { ...row, rowClass: "row-inactive" };
      } else {
        mainarray[index] = { ...row, rowClass: "" };
      }
    });

    // Set updated orderlist
    setOrderlist(mainarray);
  };

  const filterbyname = (search) => {
    setstate({ ...state, currentPage: 1 });
    Getcustomeorder(currentPage, limit, search);
  };
  const handleChange = async () => {
    console.log("handle Change is here", currentIdToChange);
    try {
      let postdata = {
        status:
          currentIdToChange.status === 1 || currentIdToChange.status === 0
            ? 9
            : 1,
        id: currentIdToChange.id,
      };
      console.log(postdata, "Check post data");
      // http://localhost:3000/api/v1/pos/customOrder/edit-pos-status
      let res = await _Api(postdata, `api/v1/pos/customOrder/edit-pos-status`);
      if (res.code === 200) {
        success("Successfully updated!");
        console.log("checkout result");
        Getcustomeorder();
      }
    } catch (err) {
      console.log(err, "error");
    }
  };

  const handleClose = () => {
    console.log(currentIdToChange, "handle Close");
  };

  return (
    <>
      <div className="main-body custom-order-table">
        <div className="main-body-row">
          <div className="main-body-row-left-col p-0">
            <div className="com-data-area1">
              <div
                className="catalog-area-header-area-control-pos"
                style={{ backgroundColor: "#E1F3F2" }}
              >
                <div className="catalog-area-header-area-control-pos-left page-back-btn-inside">
                  <Link to="/app/pos/menu">
                    <img
                      className="page-back-btn-inside-img"
                      src={base_assets + "/images/icons/arrow-left.png"}
                      alt="back"
                    />
                  </Link>
                  <h1 className="heading">{t("POS")}</h1>
                </div>

                <div
                  className="catalog-area-header-area-control-pos-right"
                  style={{ marginLeft: "65%" }}
                >
                  <div
                    className={
                      parmissiondatashow?.pos_custom_order?.View
                        ? "custom-tooltip"
                        : "d-none"
                    }
                  >
                    <Link to="/app/pos/posscreen/posorderlist">
                      <img
                        className="custom-order-img"
                        src={
                          base_assets + "images/pos/icons/custom-order-icon.png"
                        }
                        alt=""
                      />
                      <span className="com-btn custom-tooltip-text">
                        {t("Custom Order")}
                      </span>
                      { orderTotal?.order_no_count? (<span className='notification-area-count'>
                  <span className='notification-area-count-num'>
                   {orderTotal?.order_no_count}
                  </span>
                </span>):""}
                    </Link>
                  </div>
                </div>
              </div>
              <div className="com-data-area1-header delivered-header">
                <Select
                  className="limit-select short"
                  options={selectOptions}
                  value={{ label: limit, value: limit }}
                  onChange={(e) => {
                    setLimit(e.value);
                    getlimit(e.value);
                  }}
                />
                <div className="delivered-header-left custom-order-search">
                  <div className="posorderlistdiv">
                    <img
                      className="com-search-bar-search-img"
                      onClick={() => filterbyname()}
                      src={base_assets + "images/admin/icons/gray-search.png"}
                      alt=""
                    />
                    <input
                      type="text"
                      value={searchKey}
                      placeholder="Search Order no."
                      onKeyPress={(e) =>
                        e.key === "Enter" && filterbyname(e.target.value)
                      }
                      onChange={(e) => {
                        setSearchKey(e.target.value);
                      }}
                    />
                    {searchKey ? (
                      <img
                        className="search-bar-clear"
                        onClick={(e) => {
                          setSearchKey("");
                          filterbyname("");
                        }}
                        src={base_assets + "images/icons/False.png"}
                        alt=""
                      />
                    ) : (
                      ""
                    )}
                  </div>
                  <ul className="graph-indicator ms-4 text-nowrap">
                    <li
                      className="graph-indicator-single"
                      style={{ gap: "5px" }}
                    >
                      <span className="status-dot custom-order-bg"></span>
                      <label className="graph-indicator-single-label">
                        {t("Custom")}
                      </label>
                    </li>
                    <li
                      className="graph-indicator-single"
                      style={{ gap: "5px" }}
                    >
                      <span className="status-dot purple-bg"></span>
                      <label className="graph-indicator-single-label">
                        {t("Repair")}
                      </label>
                    </li>
                    <li
                      className="graph-indicator-single"
                      style={{ gap: "5px" }}
                    >
                      <span className="status-dot light-yellow-bg"></span>
                      <label className="graph-indicator-single-label">
                        {t("Reserve")}
                      </label>
                    </li>
                  </ul>
                </div>
                <DropdownFilter
                  selectedFilters={selectedFilters}
                  setSelectedFilters={setSelectedFilters}
                  onApply={Getcustomeorder}
                />
                <div className="customer-inner-data-payment-table-top-bar-right placeholder-up-input-date date ms-auto me-2">
                  <DatePicker
                    className="placeholder-up-input-field"
                    selected={TransactionDate}
                    onChange={(input) => setTransactionDate(input)}
                    name="TransactionDate"
                    dateFormat={OrgSettings?.date_picker}
                    autoComplete="none"
                  />
                  <img
                    className="placeholder-up-input-field-calender"
                    src={base_assets + "images/icons/calendar-green.svg"}
                    alt=""
                  />
                </div>
                {/* <div className=" dropdown Dailysalereport-content-area-header-leftdropdown">
                  <button
                    className="btn-style"
                    type="button"
                    id="dropdownMenuButton1"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <img
                      src={base_assets + "images/icons/ellipsis-circular.png"}
                      alt=""
                    />
                  </button>
                  <ul
                    className="dropdown-menu Dailysalereport-content-area-header-leftdropdown-menu"
                    aria-labelledby="dropdownMenuButton1"
                  >
                    <li onClick={() => getprintcustomorder()}>
                      <Link
                        className="dropdown-item Dailysalereport-content-area-header-leftdropdown-menu-item"
                        to="#"
                      >
                        <div className="dropdown-menu-img">
                          <img
                            src={
                              base_assets + "images/pos/report/print-icon.png"
                            }
                            alt=""
                          />
                        </div>
                        {t("Print")}
                      </Link>
                    </li>
                    <li>
                      <Link
                        className="dropdown-item  Dailysalereport-content-area-header-leftdropdown-menu-item"
                        to="#"
                      >
                        <div className="dropdown-menu-img">
                          <img
                            src={
                              base_assets + "images/pos/report/export-icon.png"
                            }
                            alt=""
                          />
                        </div>
                        {t("Export")}
                      </Link>
                    </li>
                    <li data-bs-toggle="modal" data-bs-target="#columnModal">
                      <Link
                        className="dropdown-item Dailysalereport-content-area-header-leftdropdown-menu-item"
                        to="#"
                      >
                        <div className="dropdown-menu-img">
                          <img
                            src={base_assets + "images/icons/column-icon.png"}
                            alt=""
                          />
                        </div>
                        {t("Column")}
                      </Link>
                    </li>
                  </ul>
                  
                </div> */}
              </div>
              <div className="com-data-area1-inner">
                <div
                  className="main-body-main-table-wrap1 customOrderlist"
                  id="table-scroll"
                  style={{ maxHeight: "48vh", overflow: "auto" }}
                >
                  <table
                    id="com-data-area_table"
                    className="common-table first-row-gray w-100"
                  >
                    <thead>
                      <tr>
                        {poscustomorder_head1.map((col, index) => {
                          if (!isColumnVisible(index)) return null;
                          const sortable =
                            Boolean(col?.sort) && Boolean(SORT_ACCESSORS[index]);
                          const active = sortConfig.index === index;
                          return (
                            <th
                              key={index}
                              className={col?.class}
                              onClick={sortable ? () => handleSort(index) : undefined}
                              style={{
                                position: "sticky",
                                top: 0,
                                zIndex: 2,
                                background: "#fff",
                                cursor: sortable ? "pointer" : undefined,
                              }}
                            >
                              {t(col?.lable)}
                              {sortable ? (
                                <div className="up-down-arrow-btn">
                                  <img
                                    className={
                                      "up-down-arrow-img up-down-arrow-img-forward" +
                                      (active && sortConfig.direction === "desc"
                                        ? ""
                                        : " active")
                                    }
                                    src={base_assets + "images/icons/up-down-arrow.png"}
                                    alt=""
                                  />
                                  <img
                                    className={
                                      "up-down-arrow-img up-down-arrow-img-reverse" +
                                      (active && sortConfig.direction === "desc"
                                        ? " active"
                                        : "")
                                    }
                                    src={
                                      base_assets +
                                      "images/icons/up-down-arrow-reverse.png"
                                    }
                                    alt=""
                                  />
                                </div>
                              ) : null}
                            </th>
                          );
                        })}
                      </tr>
                    </thead>
                    <tbody>
                      {/* Total row always stays on top; it is never sorted. */}
                      {orderTotal?.order_no_count ? (
                        <tr className="no-sort-row" style={{ background: "#fff" }}>
                          {[
                            <td key="0" style={{ background: "#fff" }}>{t("Total")}</td>,
                            <td key="1" style={{ background: "#fff" }}></td>,
                            <td key="2" style={{ background: "#fff" }}></td>,
                            <td key="3" style={{ background: "#fff" }}></td>,
                            <td key="4" style={{ background: "#fff" }}>
                              {orderTotal?.order_no_count}
                            </td>,
                            <td key="5" style={{ background: "#fff" }}>
                              {orderTotal?.sku_count}
                            </td>,
                            <td key="6">{orderTotal?.customer_count}</td>,
                            <td key="7">{orderTotal?.sku_count}</td>,
                            <td key="8">
                              {toFormatPrice(orderTotal?.amount_count, {
                                addSymbol: true,
                              })}
                            </td>,
                            <td key="9" className="main-green-text">
                              {toFormatPrice(orderTotal?.payment_count, {
                                addSymbol: true,
                              })}
                            </td>,
                            <td key="10" className="danger-text">
                              {toFormatPrice(orderTotal?.balance_due_count, {
                                addSymbol: true,
                              })}
                            </td>,
                            <td key="11"></td>,
                          ].filter((_, index) => isColumnVisible(index))}
                        </tr>
                      ) : null}

                      {sortedOrderlist.length ? (
                        sortedOrderlist.map((result, key) => {
                          const cells = [
                            <td key="0">
                              <div
                                className={
                                  ["custom_order", "mix_and_match"].includes(result?.order_type)
                                    ? "status-dot custom-order-bg"
                                    : result?.order_type === "reserve"
                                    ? "status-dot light-yellow-bg"
                                    : "status-dot purple-bg"
                                }
                              ></div>
                            </td>,
                            <td key="1">
                              <div className={"com-check"}>
                                <input
                                  id={result?.order_id}
                                  type="checkbox"
                                  onChange={(e) =>
                                    selectedproduct(e, result?.order_type)
                                  }
                                  className="reserve_item pos_reservetablehead"
                                  data-id={result?.order_id}
                                  value={result?.order_id}
                                  name="customchack"
                                  disabled={result?.notselect}
                                  checked={selecteditem.some(
                                    (item) => item.id === result?.order_id
                                  )}
                                />
                                <label
                                  htmlFor={result?.order_id}
                                  className="com-check-label"
                                ></label>
                              </div>
                            </td>,
                            <td key="2">{key + 1}</td>,
                            <td key="3">{result?.transaction_date}</td>,
                            <td key="4" className="link-color">
                              {result?.order_no}
                            </td>,
                            <td
                              key="5"
                              className="sku-col table_btn_expand_col"
                              onClick={() => setSubTablecustom(result?.order_id)}
                              id={"table-btn_" + result?.order_id}
                            >
                              {" "}
                              <img
                                className="sku-col-arrow cursor-pointer"
                                src={
                                  base_assets +
                                  "/images/icons/right_green_button.png"
                                }
                                alt=""
                              />
                              {result?.SKU}
                            </td>,
                            <td key="6" className="danger-text">
                              {result?.customer}
                            </td>,
                            <td key="7">{result?.Qty}</td>,
                            <td key="8">
                              {toFormatPrice(result?.amount, {
                                addSymbol: true,
                              })}
                            </td>,
                            <td key="9" className="main-green-text">
                              {toFormatPrice(result?.payment, {
                                addSymbol: true,
                              })}
                            </td>,
                            <td key="10" className="danger-text">
                              {toFormatPrice(result?.balance_due, {
                                addSymbol: true,
                              })}
                            </td>,
                            <td key="11" className="danger-text">
                              {result?.delivery_date}
                            </td>,
                          ];

                          return (
                            <React.Fragment key={result?.order_id ?? key}>
                              <tr
                                id={`common-main-table-wrap-${result?.order_id}`}
                                className={result?.rowClass ? result?.rowClass : ""}
                              >
                                {cells.filter((_, index) => isColumnVisible(index))}
                              </tr>
                              {excuteTable && result?.subTabledata
                                ? result.subTabledata
                                : null}
                            </React.Fragment>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan={visibleColumnCount} className="text-center">
                            {t("No Data Available In Table")}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                  className="com-data-area1-footer"
                >
                  {orderlist?.length > 0 ? (
                    <div>
                      <span className="pagination-text">
                        {orderlist?.length > 0
                          ? (state.currentPage - 1) * limit + 1
                          : 0}{" "}
                        -{" "}
                        {orderlist?.length > 0
                          ? state.currentPage * limit > orderlist?.length
                            ? orderlist?.length
                            : state.currentPage * limit
                          : 0}{" "}
                        {t("of")} {orderTotal?.order_no_count} {t("Orders")}
                      </span>
                    </div>
                  ) : (
                    ""
                  )}

                  {orderlist?.length > 0 ? (
                    <Pagination
                      total={totalPages}
                      current={currentPage}
                      pagination={(crPage) => handlePaginations(crPage)}
                    />
                  ) : (
                    ""
                  )}
                </div>
                {/* <div className="com-data-area1-footer-btn">
                  <button
                    onClick={() => {
                      GetCartdetailorder();
                    }}
                    className={
                      selecteditem?.length !== 0 && showcheckout === "blank"
                        ? "com-btn ms-auto"
                        : "com-btn ms-auto btn-disabled"
                    }
                  >
                    {t("Submit")}
                  </button>
                </div> */}
                {/* <div class="footer-btn-area">
                  
                </div> */}
                {selecteditem?.length ? (
                  <div className="action-bar">
                    <div className="action-left">
                      <span className="action-count">
                        {selecteditem?.length} item
                        {selecteditem?.length > 1 ? "s" : ""} selected
                      </span>
                      <button
                        className="action-clear"
                        onClick={() => clearItems()}
                      >
                        ✕
                      </button>
                    </div>

                    <button
                      className="action-checkout"
                      onClick={() => {
                        GetCartdetailorder();
                      }}
                    >
                      {t("Check out")}
                    </button>
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>
          <div className="main-body-row-right-col">
            {showcheckout === "sell" ? (
              <CheckoutSell
                setShowcheckout={setShowcheckout}
                setdeletestatus={setdeletestatus}
                setUpdatedCart={setUpdatedCart}
                UpdatedCart={UpdatedCart}
                setShowpayment={setShowpayment}
                showpayment={showpayment}
                ordertype={"pos_order"}
                setsearchproductstatus={setsearchproductstatus}
                searchproductstatus={searchproductstatus}
                by_custom_order={true}
                order_id={orderid ? orderid : ""}
              />
            ) : showcheckout === "payment" ? (
              <CheckoutPayment
                UpdatedCart={UpdatedCart}
                setShowcheckout={setShowcheckout}
                order_id={orderid ? orderid : ""}
                by_custom_order={true}
              />
            ) : (
              <CheckoutBlank />
            )}
          </div>
        </div>
      </div>
      <TableColumnModal
        tablehead={poscustomorder_head1}
        tblName={"tbl_pos_customorderdelivered"}
        setnewcolumndata={setnewcolumndata}
        calldatatable={Getcustomeorder}
      ></TableColumnModal>
      <ConfirmationModel
        statement={statement}
        handler_submit={
          statement === "Change Status" ? handleChange : handleClose
        }
        handler_dismiss={handleClose}
      ></ConfirmationModel>
      <button
        className="d-none"
        data-bs-toggle="modal"
        data-bs-target="#createPurchaseModal"
        id="status_query_select"
      ></button>
    </>
  );
};

export default PosOrderList;
